/**
 * useSessionHistory — Read retreat sessions from localStorage.
 * UI-INV-003: View-model hook, no engine imports.
 */
import { useState, useCallback } from "react";
import { getAllSessions } from "../state/sessionRepository";
import type { RetreatSession } from "@retreat/core";

export function useSessionHistory(): {
  sessions: RetreatSession[];
  refresh: () => void;
} {
  const [sessions, setSessions] = useState<RetreatSession[]>(() => getAllSessions());
  const refresh = useCallback(() => setSessions(getAllSessions()), []);
  return { sessions, refresh };
}
